/*!
 * This is for quick copy paste only, not a real component
 *
 * @module components/component-name
 */

import feature from '../utils/feature';
import emitter from '../utils/emitter';
import Component from './component';

const DISABLE_LIVECHAT_CLASS = 'hide-service-buttons';

export default (($, /* eslint-disable */ window, undefined /* eslint-enable */) => {
  'use strict';

  /**
   * ComponentName component class
   */
  class FAB extends Component {
    /**
     * Constructor
     */
    constructor(element, options = {}) {
      super(element, options);
      this.name = 'FAB';
      this.selectors = {};

      // -- live chat init
      // we don't wait the live chat to load but disable the chat button and only show it
      //   when the livechat become available
      this._btnLiveChat = $(FAB.selectors.liveChatButton, this.element);
      this._forceDisableLiveChat = $('body').hasClass(DISABLE_LIVECHAT_CLASS);
      if (this._btnLiveChat.length) {
        this._btnLiveChat.addClass('disabled');
        this._btnLiveChat.closest('li').addClass('disabled');

        this._btnLiveChat.append($(
          `<div class="spinner-border text-primary" role="status"><span class="visually-hidden">Loading...</span></div>`
        ));
      }

      this._showOnPageLoad = (typeof this.element.data().floatingActionButtonShowsOnPageLoad !== 'undefined' && parseInt(this.element.data().floatingActionButtonShowsOnPageLoad || '', 10) === 1);

      this._liveChatInitStarted = false;
      this._suppressHide = false;
      emitter.on('livechat-availability-change', this._onLivechatAvailabilityChange.bind(this));
    }

    /**
     * Main initializer
     *
     * @returns void
     */
    init() {
      const el = this.element;
      let wait = false;

      if (el.hasClass(this.initializedClass)) {
        // only need to initialize this component once
        return;
      }

      this.toggleButton = $(FAB.selectors.toggleButton, el);
      if (!this.toggleButton.length) {
        return;
      }

      this.toggleNav = $(`#${this.toggleButton.attr('aria-controls')}`);
      if (!this.toggleNav.length || (this.toggleNav.length && !$.contains(el[0], this.toggleNav[0]))) {
        return;
      }

      if (wait) {
        return;
      }

      // mark as initialized
      el.addClass(this.initializedClass);
      
      if (!feature.noHover) {
        el.on('pointerover', () => {
          this._show();
        });
  
        el.on('pointerout', () => {
          this._hide();
        });
      }

      el.on('click', (ev) => {
        if (el.is('.active')) {
          this._hide();
        }
        else {
          this._show();
        }
      });

      window.addEventListener('mousedown', this._onMouseDown.bind(this));
      window.addEventListener('touchstart', this._onMouseDown.bind(this));
      emitter.on('scroll', this._onScroll.bind(this));

      el.on('focusout', (ev) => {
        window.setTimeout(() => {
          if (document.activeElement !== this.element[0] && !$.contains(this.element[0], document.activeElement)) {
            this._hide();
          }
        });
      });

      if (this._btnLiveChat.length) {
        this._btnLiveChat.off('.floatingActionButton').on('click.floatingActionButton', this._onLiveChatButtonClick.bind(this));
      }

      if (this._showOnPageLoad) {
        this._show();
      }
    }

    _show() {
      this.element.addClass('active');
      this.toggleNav.attr('aria-hidden', 'false');
      $(FAB.selectors.navButton, this.toggleNav).removeAttr('tabindex');
    }

    _hide() {
      // hiding can be suppressed while loading Live Chat
      if (this._suppressHide) {
        return;
      }

      this.element.removeClass('active');
      this.toggleNav.attr('aria-hidden', 'true');
      $(FAB.selectors.navButton, this.toggleNav).attr('tabindex', -1);
    }

    _onMouseDown(ev) {
      if (ev.target !== this.element[0] && !$.contains(this.element[0], ev.target)) {
        this._hide();
      }
    }

    _onScroll(ev) {
      this._hide();
    }

    _onLiveChatButtonClick(ev) {
      //this.log('_onLiveChatButtonClick', ev.currentTarget);
      ev.preventDefault();

      if ($('.embeddedServiceSidebarMinimizedDefaultUI').length) {
        $('.embeddedServiceSidebarMinimizedDefaultUI').trigger('click');
        return;
      }

      if ($('.embeddedServiceSidebar .helpButton').length) {
        $('.embeddedServiceSidebar .helpButton').eq(0).trigger('click');
        return;
      }
      

      const t = $(ev.currentTarget);
      if (t.hasClass('disabled') || this._forceDisableLiveChat) {
        // this.log('livechat currently disabled');
        return;
      }

      const inst = window._aggrekoLiveChat ? window._aggrekoLiveChat.getInstance() : null;
      if (inst) {
        this._liveChatInitStarted = true;
        inst.onHelpButtonClick();
      }
    }

    _onLivechatAvailabilityChange(ev) {
      // this.log('_onLivechatAvailabilityChange', ev.data.available);
      
      if (this._btnLiveChat.length) {
        this._btnLiveChat.toggleClass('disabled', !ev.data.available);
        this._btnLiveChat.closest('li').toggleClass('disabled', !ev.data.available);

        this._setLivechatLoading(ev.data.initInProgress);
      }

      $('body').toggleClass('disable-service-buttons', !ev.data.available);
    }

    _setLivechatLoading(loading) {
      if (this._liveChatInitStarted) {
        //this._btnLiveChat.toggleClass('-progress', loading);
        this._btnLiveChat.closest('li').toggleClass('-progress', loading);
      }

      $('body').toggleClass('initializing-service-buttons', loading);

      // force showing the Floating Action Button while Live Chat is loading
      if (loading) {
        this._suppressHide = this._liveChatInitStarted;
        if (this._suppressHide) {
          this._show();
        }
      }
      // otherwise, if we suppressed the hiding before, hide it now
      else if (!loading && this._suppressHide) {
        this._suppressHide = false;
        this._hide();
      }
    }
  }

  FAB.selectors = {
    liveChatButton: '.btn-floating--live-chat',
    toggleButton: '.btn-floating--toggle',
    navButton: '.btn-floating'
  };

  FAB.defaults = {
    direction: 'top',
    hoverEnabled: true,
    toolbarEnabled: false
  };

  // no session - maximize button
  //sidebarHeader minimizedContainer helpButton embeddedServiceSidebarMinimizedDefaultUI

  // no session - minimize button
  //[embeddedservice-chatheader_chatheader].minimizeButton

  // no session - close button
  //[embeddedservice-chatheader_chatheader].closeButton

  return FAB;
})(jQuery, window);
